import { StyleSheet } from 'react-native';

export const decorativeElementsStyles = StyleSheet.create({
  decorativeElements: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0, // Lower z-index so content appears above
  },
  sportsDrawing: {
    position: 'absolute',
    opacity: 0.3,
  },
  iconSize: {
    width: 40,
    height: 40,
  },
});

